const baseConfig = {
  baseServerUrl: "",
  playVideoUrl: "/vid/m3u8/", //视频播放
  imgUrl: "", //图片预览
  newImgUrl: "", //图片预览
  downLoadUrl: "", //视频下载
};
if (
  process.env.NODE_ENV === "production" &&
  process.env.VUE_APP_TITLE === "test"
) {
  baseConfig.baseServerUrl = "/api/web/admin";
} else if (process.env.NODE_ENV === "development") {
  // 测试服
  // baseConfig.baseServerUrl = "/api/web/admin";
  baseConfig.baseServerUrl = "https://91lqht.ruishengces.com/api/web/admin";
  // baseConfig.baseServerUrl = "http://163.53.216.122:9492/api/web/admin"
  // 正式服
  // baseConfig.baseServerUrl = "/api/web/admin"
} else {
  baseConfig.baseServerUrl = "/api/web/admin";
}
export default baseConfig;
